module.exports = __webpack_public_path__ + "media/images/arr_r-855d25191b6d3a6a7d4e8bcc7db380c3.svg";